export enum EventBusName {
  CHECKOUT_CLICK_OPEN_REGISTER_MODAL = 'checkout-click:open-register-modal',
  HEADER_NAVIGATION_CLICK_CLOSE_ACCOUNT_MODAL = 'checkout-click:close-register-modal',
  HEADER_NAVIGATION_CLICK_OPEN_OFFCANVAS = 'header-navigation-click:open-offcanvas',
  HEADER_NAVIGATION_CLICK_OPEN_ACCOUNT_MODAL = 'header-navigation-click:open-account-modal',
  CLOSE_REGISTER_MODAL_BLOCKER = 'close-register-modal-blocker',
  USER_REGISTERED = 'user-registered',
  TOAST_NOTIFICATION = 'toast-notification',
  ACCOUNT_OR_PRICING_REFERENCE_CHANGED = 'account-or-pricing-reference-changed',
  ACCOUNT_CHANGED = 'account-changed',
  CURRENCY_CHANGED = 'currency-changed',
}
